import React from 'react'
import Svg from './Svg'
export const SvgDashboard = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M2.983 20.883h20.883v2.983H0V0h2.983zm3.73-1.492a2.237 2.237 0 11.195-4.466l2.405-4.008a2.236 2.236 0 011.874-3.459 2.237 2.237 0 011.875 3.459l2.405 4.008a2.524 2.524 0 01.343-.004l3.972-6.947a2.238 2.238 0 111.699.971l-3.971 6.947a2.235 2.235 0 01-1.847 3.499 2.237 2.237 0 01-1.875-3.459l-2.406-4.009a2.088 2.088 0 01-.391 0l-2.404 4.009a2.24 2.24 0 01-1.874 3.459z" />
  </Svg>
))
SvgDashboard.isIcon = true
export default SvgDashboard
